import React from 'react';
import Style from './Navbar.module.scss';
import Toggler from "./home/Toggler";
import { HashLink as Link } from 'react-router-hash-link';
import { Box } from "@mui/material";
import { info, singlePage } from "../info/Info";

// ✅ استيراد صورة اللوجو
import flutterLogo from "../img/flutter.png";

const links = [
    {
        name: 'Home',
        to: '',
        active: 'home'
    },
    {
        name: 'About Me',
        to: 'about',
        active: 'about'
    },
    {
        type: 'image',
        src: flutterLogo,
        to: '',
        active: 'home'
    },
    {
        name: 'Projects',
        to: 'portfolio',
        active: 'portfolio'
    }
];

// scroll offset
const scrollWidthOffset = (el) => {
    const yCoordinate = el.getBoundingClientRect().top + window.pageYOffset;
    const yOffset = -80;
    window.scrollTo({ top: yCoordinate + yOffset, behavior: 'smooth' });
};

export default function Navbar({ darkMode, handleClick, active, setActive }) {
    return (
        <Box
            component={'nav'}
            width={'100%'}
            position={singlePage ? 'fixed' : 'relative'}
            className={darkMode ? Style.dark : Style.light}
        >
            <Box
                component={'ul'}
                display={'flex'}
                justifyContent={'center'}
                alignItems={'center'}
                gap={{ xs: '2rem', md: '8rem' }}
                textTransform={'none'}
                fontSize={'1rem'}
            >
                {links.map((link, index) => (
                    <Box
                        key={index}
                        component={'li'}
                        className={(link.active === active && !link.type) ? Style.active : ''}
                        sx={{ borderImageSource: info.gradient }}
                    >
                        <Link
                            to={singlePage ? `#${link.to}` : `/${link.to}`}
                            scroll={el => scrollWidthOffset(el)}
                            smooth
                            onClick={() => setActive(link.active)}
                            className={Style.link}
                        >
                            {/* 🔥 هنا بقى الفرق */}
                            {link.type === 'image' ? (
                            <img
                            src={link.src}
                            alt="logo"
                            style={{
                                width: '80px',
                                height: '80px',
                                objectFit: 'contain',
                                filter: darkMode ? 'invert(1)' : 'invert(0)',
                                transition: '0.3s'
                            }}
                            />
                            ) : (
                                <p style={{ padding: '0.5rem 0' }}>
                                    {link.name}
                                </p>
                            )}
                        </Link>
                    </Box>
                ))}

                <li>
                    <Toggler darkMode={darkMode} handleClick={handleClick} />
                </li>
            </Box>
        </Box>
    );
}